// extracted by mini-css-extract-plugin
export var editButton = "_q4-0";